module.exports = new __parcel__URL__("saucerful-of-secrets-the-pink-floyd-odyssey.fa731654.jpg").toString();